import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Dev-only: Filtere nervige ResizeObserver-Konsolenmeldungen in Chrome/DevTools
if (process.env.NODE_ENV === 'development') {
  const originalConsoleError = console.error;
  console.error = (...args) => {
    try {
      const first = args && args[0];
      if (
        typeof first === 'string' && (
          first.includes('ResizeObserver loop completed with undelivered notifications') ||
          first.includes('ResizeObserver loop limit exceeded')
        )
      ) {
        return; // ignorieren in Dev
      }
    } catch (_) {}
    return originalConsoleError(...args);
  };

  const ignoreRo = (msg) => typeof msg === 'string' && (
    msg.includes('ResizeObserver loop completed with undelivered notifications') ||
    msg.includes('ResizeObserver loop limit exceeded')
  );

  // Früh abfangen, bevor das CRA-Overlay lauscht
  window.addEventListener('error', (event) => {
    if (ignoreRo(event?.message)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  window.addEventListener('unhandledrejection', (event) => {
    const msg = event?.reason?.message || '';
    if (ignoreRo(msg)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  // Als Fallback: Dev-Overlay von WDS/Cra ausblenden (nur Dev)
  try {
    const style = document.createElement('style');
    style.setAttribute('data-hide-overlay', 'true');
    style.innerHTML = `
      #webpack-dev-server-client-overlay,
      #webpack-dev-server-client-overlay *,
      iframe#webpack-dev-server-client-overlay,
      #webpack-dev-server-client-overlay-div {
        display: none !important;
        visibility: hidden !important;
        opacity: 0 !important;
        pointer-events: none !important;
      }
    `;
    document.head.appendChild(style);

    const hideOverlayNodes = () => {
      const ids = [
        'webpack-dev-server-client-overlay',
        'webpack-dev-server-client-overlay-div'
      ];
      ids.forEach((id) => {
        const el = document.getElementById(id);
        if (el) {
          el.style.display = 'none';
          el.style.visibility = 'hidden';
          el.style.pointerEvents = 'none';
          el.style.opacity = '0';
        }
      });
      const iframe = document.querySelector('iframe#webpack-dev-server-client-overlay');
      if (iframe) {
        iframe.style.display = 'none';
        iframe.style.visibility = 'hidden';
        iframe.style.pointerEvents = 'none';
        iframe.style.opacity = '0';
      }
    };
    hideOverlayNodes();
    const mo = new MutationObserver(hideOverlayNodes);
    mo.observe(document.documentElement, { childList: true, subtree: true });
  } catch (_) {}
}


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


